// extracted by mini-css-extract-plugin
export default {"clipboard":"ClipBoard_clipboard__ragyY"};